import { LandingPageConfig } from "landing/objects/LandingPageConfig";
import type { Subscription } from "landing/objects/Subscription";
import Subscription2FAInitResult from "landing/objects/Subscription2FAInitResult";
import SubscriptionResult from "landing/objects/SubscriptionResult";
import { LandingPageTemplateOptions } from "landing/objects/templateOptions/LandingPageTemplateOptions";
import type { ThunkResult } from "main/reducers/IMainAppState";
import { APIGet, APIPost } from "shared/actions/FetchActions";

export function GetLandingPageConfigs(
  lpCode: string,
): ThunkResult<Promise<LandingPageConfig[]>> {
  return async (dispatch) => {
    const fetchResult: Response = await dispatch(
      APIGet(`/landing-pages/v3/${lpCode}`),
    );
    const response: any[] = await fetchResult.json();
    return response.map((json) => {
      const landingPageTemplateOption =
        LandingPageTemplateOptions[json.offerLpTemplateId];
      const landingPageConfig: LandingPageConfig = new LandingPageConfig({
        ...json,
        ...landingPageTemplateOption,
      });
      landingPageConfig.lpCode = lpCode;
      return landingPageConfig;
    });
  };
}

export function Subscribe(
  subscription: Subscription,
): ThunkResult<Promise<SubscriptionResult>> {
  return async (dispatch) => {
    const apiPath: string = `/landing-pages/v3/action/_subscribe`;
    const fetchResult: Response = await dispatch(
      APIPost(apiPath, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify(subscription),
      }),
    );
    const response: any = await fetchResult.json();
    return new SubscriptionResult(response);
  };
}

export function Subscribe2FAInit(
  subscription: Subscription,
): ThunkResult<Promise<Subscription2FAInitResult>> {
  return async (dispatch) => {
    const apiPath: string = `/landing-pages/v3/action/_2fa`;
    const fetchResult: Response = await dispatch(
      APIPost(apiPath, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify(subscription),
      }),
    );
    const response: any = await fetchResult.json();
    return new Subscription2FAInitResult(response);
  };
}

export function Subscribe2FAFinalize(
  subscription: Subscription,
  subscription2FAInitResult: Subscription2FAInitResult,
  otp: string,
): ThunkResult<Promise<SubscriptionResult>> {
  return async (dispatch) => {
    const apiPath: string = `/landing-pages/v3/action/_subscribe.2fa`;
    const fetchResult: Response = await dispatch(
      APIPost(apiPath, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          ...subscription,
          nonce: subscription2FAInitResult.nonce,
          otp,
        }),
      }),
    );
    const response: any = await fetchResult.json();
    return new SubscriptionResult(response);
  };
}
